jQuery(document).ready(function($){
  $('.hasSeenBtn').on('click', function(){
    var userID = $(this).attr('data-id');
    $.ajax({
      type : "post",
      url : "/wp-admin/admin-ajax.php",
      data : {
        action: "set_presentation",
        "userID" : userID
      },
      beforeSend: function() {

      },
      success: function(response, e) {
        $('.presentationWrp').addClass('remove');
        setTimeout(function () {
          $('.presentationWrp').remove();
        }, 1000);
      },
      complete: function() {

      },
    });
  });
});
